function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _excluded = ["border", "cssModule", "className", "fixedWidth", "flip", "inverse", "name", "pulse", "rotate", "size", "spin", "stack", "tag", "ariaLabel"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/* eslint-disable no-unused-expressions */


import React from 'react';
export var srOnlyStyle = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: '0px',
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0px, 0px, 0px, 0px)',
  border: '0px'
};
/**
 * A React component for the font-awesome icon library.
 *
 *
 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
 * @param {Boolean} [border=false] Whether or not to show a border radius
 * @param {String} [className] An extra set of CSS classes to add to the component
 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
 * @param {String} [flip=false] Flip the icon's orientation.
 * @param {Boolean} [inverse=false]Inverse the icon's color
 * @param {String} name Name of the icon to use
 * @param {Boolean} [pulse=false] Rotate icon with 8 steps (rather than smoothly)
 * @param {Number} [rotate] The degress to rotate the icon by
 * @param {String} [size] The icon scaling size
 * @param {Boolean} [spin=false] Spin the icon
 * @param {String} [stack] Stack an icon on top of another
 * @param {String} [tag=span] The HTML tag to use as a string (eg 'i' or 'em')
 * @module FontAwesome
 * @type {ReactClass}
 */

var FontAwesomeAPM = /*#__PURE__*/function (_React$Component) {
  _inherits(FontAwesomeAPM, _React$Component);

  var _super = _createSuper(FontAwesomeAPM);

  function FontAwesomeAPM() {
    _classCallCheck(this, FontAwesomeAPM);

    return _super.apply(this, arguments);
  }

  _createClass(FontAwesomeAPM, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          border = _this$props.border,
          cssModule = _this$props.cssModule,
          className = _this$props.className,
          fixedWidth = _this$props.fixedWidth,
          flip = _this$props.flip,
          inverse = _this$props.inverse,
          name = _this$props.name,
          pulse = _this$props.pulse,
          rotate = _this$props.rotate,
          size = _this$props.size,
          spin = _this$props.spin,
          stack = _this$props.stack,
          _this$props$tag = _this$props.tag,
          Tag = _this$props$tag === void 0 ? 'i' : _this$props$tag,
          ariaLabel = _this$props.ariaLabel,
          props = _objectWithoutProperties(_this$props, _excluded);

      var classNames = [];

      if (cssModule) {
        classNames.push(cssModule.fa);
        classNames.push(cssModule["fa-".concat(name)]);
        size && classNames.push(cssModule["fa-".concat(size)]);
        spin && classNames.push(cssModule['fa-spin']);
        pulse && classNames.push(cssModule['fa-pulse']);
        border && classNames.push(cssModule['fa-border']);
        fixedWidth && classNames.push(cssModule['fa-fw']);
        flip && classNames.push(cssModule["fa-flip-".concat(flip)]);
        rotate && classNames.push(cssModule["fa-rotate-".concat(rotate)]);
        stack && classNames.push(cssModule["fa-stack-".concat(stack)]);
        inverse && classNames.push(cssModule['fa-inverse']);
      } else {
        classNames.push(name);
        size && classNames.push(size);
        spin && classNames.push('spin');
        pulse && classNames.push('pulse');
        border && classNames.push('border');
        fixedWidth && classNames.push('fw');
        flip && classNames.push("flip-".concat(flip));
        rotate && classNames.push("rotate-".concat(rotate));
        stack && classNames.push("stack-".concat(stack));
        inverse && classNames.push('inverse');
        var fa = classNames.map(function (iconName) {
          return "fa-".concat(iconName);
        });
        fa.unshift('fa');
        classNames = fa;
      } // Add any custom class names at the end.


      className && classNames.push(className);
      return /*#__PURE__*/React.createElement(Tag, _extends({}, props, {
        "aria-hidden": true,
        className: classNames.join(' ')
      }), ariaLabel && /*#__PURE__*/React.createElement("span", {
        style: srOnlyStyle
      }, ariaLabel));
    }
  }]);

  return FontAwesomeAPM;
}(React.Component);

export { FontAwesomeAPM as default };
FontAwesomeAPM.displayName = "FontAwesomeAPM";